import styles from "./PerformanceUpsellParagraph.module.css";
import { ButtonTextOnly } from "src/components/ui-components/ButtonTextOnly/ButtonTextOnly";
import { AnchorButtonTextOnly } from "src/components/ui-components/ButtonTextOnly/AnchorButtonTextOnly";

import { useEditorQueryPerformanceState } from "src/components/page-components/QueryPage/status/useEditorQueryPerformanceState";
import { setIsMenuOpen } from "shared/ContextSwitcher/menuStore";
import { useActiveContext } from "shared/ContextSwitcher/store";

export function PerformanceUpsellParagraph() {
  const activeContext = useActiveContext();
  const { canSelectPerformance, performance, performanceTiers } =
    useEditorQueryPerformanceState();

  if (!canSelectPerformance || !activeContext) {
    return null;
  }

  const maxPerformance =
    performanceTiers.slice(-1)[0]?.publicPerformanceTierKey;

  const maxAvailablePerformance = performanceTiers
    .slice()
    .reverse()
    .find((perf) => !("disabled" in perf))?.publicPerformanceTierKey;

  if (performance === maxPerformance) {
    return null;
  }

  return (
    <div>
      <p>
        Try using a larger query engine for better performance.{" "}
        <AnchorButtonTextOnly
          size="S"
          theme="secondary"
          insideText
          href="https://dune.com/docs/query/query-executions/?h=medium#query-engine-size"
          target="_blank"
          rel="noreferrer"
        >
          Learn more here
        </AnchorButtonTextOnly>
        .
      </p>

      {performance === maxAvailablePerformance && (
        <div className={styles.upgradeOrSwitchContext}>
          <p>
            To gain access to the <em>Large</em> query engine,{" "}
            <AnchorButtonTextOnly
              size="S"
              theme="secondary"
              insideText
              href="/pricing"
              target="_blank"
            >
              upgrade
            </AnchorButtonTextOnly>{" "}
            to a paid team plan, or{" "}
            <ButtonTextOnly
              size="S"
              theme="secondary"
              insideText
              onClick={() => setIsMenuOpen(true)}
            >
              switch
            </ButtonTextOnly>{" "}
            to a paid team if you already have one.
          </p>
        </div>
      )}
    </div>
  );
}
